export default __webpack_public_path__ + "static/media/failed-to-load.78ce3333.svg";